import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { AngularLibraryBootstrapModule } from 'angular-library';

export * from './models/user-data';
export * from './models/dirette';
export * from './models/statistiche';
export * from './models/giocatori';
export * from './models/squadre';
export * from './models/marcature';
export * from './models/match';
export * from './models/data-evento';
export * from './models/eventi';
export * from './models/eventi-dirette';
export * from './models/stati-dirette';
export * from './models/time-info';
export * from './models/portali';
export * from './models/visite-portale';
export * from './models/assegnazione';

@NgModule({
    imports: [AngularLibraryBootstrapModule],
    exports: [
        FormsModule,
        CommonModule,
        AngularLibraryBootstrapModule
    ],
    declarations: []
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts